export default __webpack_public_path__ + "static/media/password.8a0541d8.png";